module.exports = __webpack_public_path__ + "img/car_.7a80c278.png";